import type { FaireProductEntity } from "../../entity_types/product";

export const p_b52dztv4mx: FaireProductEntity = {
  token: "p_b52dztv4mx",
  type: "product",
  name: 'Classic Mint Julep Cup-4"H(10oz)-790',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/c66d68e8bd24efa8b317fa04cb6f1582007d87d8ebfb21f356fc8e7a748b4c08.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description:
    "You don't have to be watching the Kentucky Derby to enjoy a mint julep with this classic mint julep glass. Made of glass and accented with detailing around the lip and base — this glass will keep your mint julep frosty and cool no matter what you're doing.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:10.414Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
